import { defineStyleConfig } from '@chakra-ui/system';

const notification = {
    display: 'inline-flex',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    minWidth: 5,
    height: 5,
    color: 'white',
    fontSize: 'xs',
    backgroundColor: 'blue.500',
    border: '1px solid',
    borderColor: 'white',
    borderRadius: 'full',
};

const slt = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 0,
    padding: 0,
    height: '24px',
    width: '97px',
    backgroundColor: '#C3CDD5',
    color: 'black',
    textTransform: 'none',
    textStyle: 'slt-body-text-lg',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
};

export const Badge = defineStyleConfig({
    variants: {
        notification,
        slt,
    },
});
